// Dynamic Theme Configuration - เพิ่ม theme ใหม่ได้โดยไม่ต้องแก้ code
// ในอนาคตสามารถดึงข้อมูลนี้จาก API แทนได้

export interface ThemeMetadata {
    id: string
    name: string
    displayName: string
    folder: string
    description?: string
    colorScheme: {
        primary: string
        secondary: string
    }
    assets: {
        styles: string[]
        scripts: string[]
        favicon: string
        logo: string
    }
    status: 'active' | 'beta' | 'deprecated'
}

// ⚡ Central Theme Registry - เพิ่ม theme ใหม่ที่นี่
export const AVAILABLE_THEMES: Record<string, ThemeMetadata> = {
    'huay-asia': {
        id: 'huay-asia',
        name: 'HuayAsia',
        displayName: 'HuayAsia',
        folder: 'HuayAsia',
        description: 'ธีมสีเขียวธรรมชาติ เน้นความมั่นคงและน่าเชื่อถือ',
        colorScheme: {
            primary: '#28a745',
            secondary: '#6c757d'
        },
        assets: {
            styles: ['/css/bootstrap.min.css', '/css/style.css'],
            scripts: ['/js/script.js'],
            favicon: '/img/favicon.ico',
            logo: '/img/logo.png'
        },
        status: 'active'
    },
    'lenhuay': {
        id: 'lenhuay',
        name: 'Lenhuay',
        displayName: 'Lenhuay',
        folder: 'Lenhuay',
        description: 'ธีมสีแดงเข้ม-ทอง ตัดกับฟ้าอมเขียว ให้ความรู้สึกโดดเด่นและพรีเมียม',
        colorScheme: {
            primary: '#9c1515',
            secondary: '#ffc833'
        },
        assets: {
            styles: ['/css/bootstrap.min.css', '/css/style.css'],
            scripts: ['/js/script.js'],
            favicon: '/img/favicon.ico',
            logo: '/img/logo.png'
        },
        status: 'active'
    },
    'huay-fast': {
        id: 'huay-fast',
        name: 'HuayFast',
        displayName: 'HuayFast',
        folder: 'HuayFast',
        description: 'ธีมสีน้ำเงินสดใส เน้นความรวดเร็วและทันสมัย',
        colorScheme: {
            primary: '#007bff',
            secondary: '#6c757d'
        },
        assets: {
            styles: ['/css/bootstrap.min.css', '/css/style.css'],
            scripts: ['/js/script.js'],
            favicon: '/img/favicon.ico',
            logo: '/img/logo.png'
        },
        status: 'active'
    },

    // 🚀 ตัวอย่างการเพิ่ม themes ใหม่ - เอา comment ออกเพื่อเปิดใช้งาน
    'huay-premium': {
        id: 'huay-premium',
        name: 'HuayPremium',
        displayName: 'HuayPremium (ทองหรูหรา) 🏆',
        folder: 'HuayPremium',
        description: 'ธีมสีทองหรูหรา สำหรับสมาชิก VIP',
        colorScheme: {
            primary: '#ffd700',
            secondary: '#6c757d'
        },
        assets: {
            styles: ['/css/bootstrap.min.css', '/css/style.css'],
            scripts: ['/js/script.js'],
            favicon: '/img/favicon.ico',
            logo: '/img/logo.png'
        },
        status: 'beta' // เปลี่ยนเป็น 'active' เมื่อพร้อมใช้งาน
    }
}

// Helper functions
export const getActiveThemes = (): ThemeMetadata[] => {
    return Object.values(AVAILABLE_THEMES).filter(theme => theme.status === 'active')
}

export const getAllThemes = (): ThemeMetadata[] => {
    return Object.values(AVAILABLE_THEMES)
}

export const getThemesForEnvironment = (isDev: boolean = false): ThemeMetadata[] => {
    if (isDev) {
        // Development: แสดง themes ทั้งหมด (รวม beta)
        return Object.values(AVAILABLE_THEMES).filter(theme =>
            theme.status === 'active' || theme.status === 'beta'
        )
    } else {
        // Production: แสดงเฉพาะ active themes
        return getActiveThemes()
    }
}

export const getThemeById = (id: string): ThemeMetadata | null => {
    return AVAILABLE_THEMES[id] || null
}

export const getThemeIds = (): string[] => {
    return Object.keys(AVAILABLE_THEMES)
}

export const getDefaultTheme = (): ThemeMetadata => {
    return AVAILABLE_THEMES['huay-asia'] // หรือใช้ theme แรกที่ active
}

// สำหรับ production สามารถใช้ function นี้เพื่อดึงจาก API
export const loadThemesFromAPI = async (): Promise<Record<string, ThemeMetadata>> => {
    try {
        // ในอนาคตเรียก API ตรงนี้
        // const response = await fetch('/api/themes/available')
        // return await response.json()

        // ตอนนี้ return static config
        return AVAILABLE_THEMES
    } catch (error) {
        console.error('Failed to load themes from API, using fallback:', error)
        return AVAILABLE_THEMES
    }
}
